import { CommonModule } from '@angular/common';
import { Component, inject, type Signal } from '@angular/core';
import { GeneralSelectors } from '@hunting-nature/Secacam/shared/redux/general/general.reducer';
import type { Contact } from '@hunting-nature/shared-core/interfaces/contact-response.interface';
import { AppButtonComponent } from '@hunting-nature/shared-ui/components/app-button/app-button.component';
import { ContactsAvatarsComponent } from '@hunting-nature/shared-ui/components/contacts-avatars/contacts-avatars.component';
import { pickIcons } from '@hunting-nature/shared-ui/helper/icon-registry.const';
import { IonCard, IonIcon } from '@ionic/angular/standalone';
import { TranslocoPipe } from '@jsverse/transloco';
import { Store } from '@ngrx/store';
import { addIcons } from 'ionicons';

import { GeneralActions } from '../../../shared/redux/general/general.actions';
import { MenuSelectors } from '../redux/menu.reducer';

@Component({
  selector: 'app-contacts-card',
  templateUrl: './contacts-card.html',
  styleUrl: './contacts-card.scss',
  standalone: true,
  imports: [CommonModule, IonCard, IonIcon, TranslocoPipe, AppButtonComponent, ContactsAvatarsComponent],
})
export class ContactsCard {
  // services
  private readonly store = inject(Store);

  // UI bindings
  protected readonly contacts$$: Signal<Array<Contact>> = this.store.selectSignal(MenuSelectors.getContacts);
  protected readonly contactsLoading$$: Signal<boolean> = this.store.selectSignal(MenuSelectors.isContactsLoading);
  protected readonly hasContacts$$: Signal<boolean> = this.store.selectSignal(MenuSelectors.hasContacts);
  protected readonly useDarkMode$$ = this.store.selectSignal(GeneralSelectors.isUseDarkMode);

  constructor() {
    addIcons(pickIcons('plus', 'arrow-right'));
  }

  handleGoToContacts(): void {
    this.store.dispatch(GeneralActions.goToMenuContacts());
  }
}
